<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer055">
<p class="structure-nxt" id="calibre_pb_5"> </p>
<p class="copyright"><span class="toc" id="calibre_toc_2">Copyright</span><span class="toc"> © 2019 Mel</span><span class="toc">isa Caprio</span></p>
<p class="copyright"><span class="toc">Cover &amp; Layout Design: Je</span><span class="toc">rmaine Lau</span></p>
<p class="copyright"><span class="toc">All photos by Mel</span><span class="toc">isa Caprio</span></p>
<p class="copyright"><span class="toc">Published by Mango Publishing Group, a division of Mango </span><span class="toc">Media Inc.</span></p>
<p class="copyright"><span class="toc">Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our ope</span><span class="toc">n society.</span></p>
<p class="copyright"><span class="toc">Uploading or distributing photos, scans, or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our author</span><span class="toc">’s rights.</span></p>
<p class="copyright"><span class="toc">For permission requests, please contact the pub</span><span class="toc">lisher at:</span></p>
<p class="copyright"><span class="toc">Mango Publis</span><span class="toc">hing Group</span><span class="toc"><br class="calibre3"/>2850 Douglas Road,</span><span class="toc"> 2nd Floor</span><span class="toc"><br class="calibre3"/>Coral Gables, FL</span><span class="toc"> 33134 USA</span><span class="toc"><br class="calibre3"/></span><a href="mailto:info@mango.bz"><span class="toc">inf</span><span class="toc">o@mango.bz</span></a></p>
<p class="copyright"><span class="toc">Postcards to the Universe: Harness the Universe’s Power and Manifest Y</span><span class="toc">our Dreams</span></p>
<p class="copyright"><span class="toc">ISBN: (p) 978-1-64250-059-2 (e) 978-1-6</span><span class="toc">4250-060-8</span></p>
<p class="copyright"><span class="toc">LCCN: </span><span class="toc">2019944236</span></p>
<p class="copyright"><span class="toc">BISAC: OCC014000 BODY, MIND &amp; SPIRIT / N</span><span class="toc">ew Thought</span></p>
<p class="normal"><span class="charoverride4"> </span></p>
<div class="calibre1" id="calibre_pb_6"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_004.vue?dc5ad474